import requestEntityTabTemplate from '@/requests/layout/requestEntityTabTemplate';

export default requestEntityTabTemplate(['datasets'], ({ requests }) => requests.create);
